const Design = ({ design, index }) => {
    return (
        <div className="imagePhoto">
            <img key={index} className="image-fluid" src={design} />
        </div>
    )
}

export default Design